var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconamoonCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2997 12.9303V13.9703C10.2997 14.4703 9.36973 15.2203 8.84973 15.1703C6.54973 15.0303 4.01976 15.3603 1.74976 15.1703C0.929756 15.1003 0.319766 14.5103 0.259766 13.6803V3.85026C0.259766 3.21026 0.989761 2.40031 1.62976 2.40031H3.03973V1.40031C3.03973 0.760313 3.94979 0.200282 4.52979 0.150282C6.80978 -0.029718 9.31976 0.290282 11.6298 0.150282C12.4398 0.250282 13.0098 0.810303 13.0798 1.6403V11.4703C13.0798 12.1003 12.3398 12.9203 11.7098 12.9203H10.2997V12.9303ZM4.32977 0.660292C3.87977 0.770292 3.52974 1.14027 3.47974 1.61027V11.4403C3.50974 11.9003 3.82977 12.2703 4.25977 12.4103L11.6198 12.4403C12.1098 12.4103 12.5398 12.0103 12.5798 11.5203C12.5398 8.13031 12.6498 4.71031 12.5298 1.33031C12.3898 0.950305 12.0697 0.690282 11.6597 0.650282H4.32977V0.660292ZM3.03973 2.90031H1.58978C1.24978 2.90031 0.759756 3.43032 0.749756 3.78032V13.7803C0.789756 14.2703 1.21978 14.6703 1.70978 14.7003H8.92975C9.28975 14.7003 9.84973 14.1703 9.84973 13.8203V12.9403H4.35974C3.86974 12.9403 3.02979 12.2003 3.02979 11.7003V2.91026L3.03973 2.90031Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconamoonCopy);
export default __webpack_public_path__ + "static/media/iconamoon_copy.b665b8fd927afb8e9b9bede7ee83372e.svg";
export { ForwardRef as ReactComponent };